module.exports = __webpack_public_path__ + "img/egg.dea9800c.svg";